import React from 'react';
import { Home, Camera, CalendarDays, BarChart3, User, Crown } from 'lucide-react';

export function BottomNavBar({ 
  currentPage, 
  onNavigate, 
  isExpired = false,
  showPersonalDialog,
  isDesktop = false
}) {

  const navItems = [
    { id: 'home', icon: Home, label: 'Home', premium: false },
    { id: 'photos', icon: Camera, label: 'Photos', premium: true },
    { id: 'calendar', icon: CalendarDays, label: 'Calendar', premium: false },
    { id: 'statistics', icon: BarChart3, label: 'Stats', premium: true },
    { id: 'personal', icon: User, label: 'Personal', premium: false },
  ];

  return (
      <nav 
        className={`fixed bottom-0 z-50 bg-slate-950/95 backdrop-blur-sm border-t border-slate-800/60 ios-taskbar ${
          isDesktop ? 'right-0' : 'left-0 right-0'
        }`}
        style={isDesktop ? { left: '400px' } : undefined}
        data-desktop-nav={isDesktop ? "true" : undefined}
      >
        <div className="flex items-center justify-around py-2.5 px-4">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id || (item.id === 'home' && !currentPage);
            
            const handleClick = () => {
              if (item.id === 'personal' && showPersonalDialog) {
                showPersonalDialog();
              } else {
                onNavigate(item.id === 'home' ? null : item.id);
              }
            };
            
            return (
              <button
                key={item.id}
                onClick={handleClick}
                className={`flex flex-col items-center gap-1 transition-colors duration-200 relative ${
                  isActive 
                    ? 'text-white' 
                    : 'text-slate-500 hover:text-slate-300'
                }`}
                data-testid={`taskbar-${item.id}-btn`}
              >
                <Icon size={22} strokeWidth={1.5} />
                <span className="text-[10px] font-medium">{item.label}</span>
                {item.premium && isExpired && (
                  <Crown size={10} className="absolute -top-1 -right-2 text-amber-400" />
                )}
              </button>
            );
          })}
        </div>
      </nav>
  );
}

export default BottomNavBar;
